import CustomerService from "../../pages/enterprises/CustomerService";
import Enterprise from "../../pages/enterprises/Enterprise";
import ExploreService from "../../pages/enterprises/ExploreService";
import MarketingService from "../../pages/enterprises/MarketingService";
import MatchTalent from "../../pages/enterprises/MatchTalent";
import MatchTalentHire from "../../pages/enterprises/MatchTalentHire";
import MobileDesignService from "../../pages/enterprises/MobileDesignService";
import SalesService from "../../pages/enterprises/SalesService";
import SalesServiceSubscription from "../../pages/enterprises/SalesServiceSubscription";

export const enterPrisesPaths = {
  math_talent_hire: "/match-talent-hire",
  math_talent: "/match-talent",
  Enterprise: "/",
  ExploreService: "/explore-service",
  SalesServiceSubscription: "/sales-service-subscription",
  SalesService: "/sales-service",
  DesignService: "/design-service",
  marketing_services: "/market-service",
  customer_service: "/customer-service"
};

export const AllEnterPrisesRoutes = [
  {
    name: "Match Talent hire",
    path: enterPrisesPaths?.math_talent_hire,
    element: <MatchTalentHire />,
    isPrivate: false,
  },
  {
    name: "Customer Service",
    path: enterPrisesPaths?.customer_service,
    element: <CustomerService />,
    isPrivate: false,
  },
  {
    name: "Marketing Service",
    path: enterPrisesPaths?.marketing_services,
    element: <MarketingService />,
    isPrivate: false,
  },
  // {
  //   name: "Match Talent",
  //   path: enterPrisesPaths?.math_talent,
  //   element: <MatchTalent />,
  //   isPrivate: false,
  // },
  {
    name: "Enterprise",
    path: enterPrisesPaths?.Enterprise,
    element: <Enterprise />,
    isPrivate: false,
  },
  {
    name: "ExploreService",
    path: enterPrisesPaths?.ExploreService,
    element: <ExploreService />,
    isPrivate: false,
  },
  {
    name: "SalesService",
    path: enterPrisesPaths?.SalesService,
    element: <SalesService />,
    isPrivate: false,
  },
  {
    name: "Mobile Design Service",
    path: enterPrisesPaths?.DesignService,
    element: <MobileDesignService />,
    isPrivate: false,
  },
  {
    name: "SalesServiceSubscription",
    path: enterPrisesPaths?.SalesServiceSubscription,
    element: <SalesServiceSubscription />,
    isPrivate: false,
  },
];
